import { injectIntl } from "react-intl";
import { KeyValue } from "./KeyValue";
class Tag extends KeyValue {
  keyPlaceholderId = 'au.filters.tag.key';
  valuePlaceholderId = 'au.filters.tag.value';
}

export default injectIntl(Tag);
